var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.79,512H26.95C12.03,512,0,499.92,0,485.05V269.47c0-14.87,12.03-26.95,26.95-26.95h80.84 c14.89,0,26.95,12.08,26.95,26.95v215.58C134.74,499.92,122.68,512,107.79,512z M296.42,512h-80.84 c-14.92,0-26.95-12.08-26.95-26.95V26.95C188.63,12.08,200.66,0,215.58,0h80.84c14.89,0,26.95,12.08,26.95,26.95v458.11 C323.37,499.92,311.32,512,296.42,512z M485.05,512h-80.84c-14.92,0-26.95-12.08-26.95-26.95V188.63 c0-14.87,12.03-26.95,26.95-26.95h80.84c14.89,0,26.95,12.08,26.95,26.95v296.42C512,499.92,499.95,512,485.05,512z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.a6578da43f490d3ce4db03f1267691e4.svg";
export { ForwardRef as ReactComponent };